import { RouteObject } from "react-router-dom";
import templateMatserRouteList from "./routeList";
import ObservationTemplateMaster from "./ObservationTemplateMatser";
import ObservationTemplateAddOrEditPage from "./ObservationTemplateMatser/AddOrEditPage";
import { lazy } from "react";
import PrivateRoute from "../../Authentication/component/PrivateRoute";
import Loader from "../../utilis/component/SkeletonLoading/Loader";
import FormMaster from "./formMaster/components/AddOrdEditForm";
const LabTemplate = lazy(()=>import("./LabTemplate"));
const AddOrEditAddOrEditLabTemplate = lazy(()=>import("./LabTemplate/AddOrEditLabTemplate"));
const RadiologyTemplate = lazy(()=>import("./RadiologyTemplate"));
const AddOrEditRadiologyTemplate = lazy(()=>import("./RadiologyTemplate/AddOrEditRadiologyTemplate"));
const PFSHTemplate = lazy(() => import("./PFSHTemplateMaster"));
const AddOrEditPFSHTemplate = lazy(
  () => import("./PFSHTemplateMaster/AddOrEditPFSHTemplate")
);
const PackageAddOrEditPage = lazy(
  () => import("./PackageMaster/AddOEditPackage")
);
const PackageMaster = lazy(() => import("./PackageMaster/index"));
const AddOrEditIMgntType = lazy(() => import("./ManagementTypeMaster/AddOrEditType"));
const ManagementMaster = lazy(() => import("./ManagementTypeMaster/index"));

const templateMasterRoutes: RouteObject[] = [
  {
    path: templateMatserRouteList.observationTemplateMaster,
    children: [
      {
        path: "",
        element: <ObservationTemplateMaster />,
      },
      {
        path: templateMatserRouteList.addOrEdit,
        element: <ObservationTemplateAddOrEditPage />,
      },
    ],
  },
  {
    path: templateMatserRouteList.PackageMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <PackageMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: templateMatserRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <PackageAddOrEditPage />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: templateMatserRouteList.pfshTemplateMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <PFSHTemplate />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: templateMatserRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditPFSHTemplate />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: templateMatserRouteList.radiolodyTemplateMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <RadiologyTemplate />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: templateMatserRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditRadiologyTemplate />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: templateMatserRouteList.labTemplateMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <LabTemplate />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: templateMatserRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditAddOrEditLabTemplate />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: templateMatserRouteList.managementMaster,
    children: [
      {
        path: "",
        element:<PrivateRoute> 
                   <Loader>
                     <ManagementMaster/>
                   </Loader>
                </PrivateRoute>,
      },
      {
        path: templateMatserRouteList.addOrEdit,
        element:
        <PrivateRoute> 
                   <Loader>
                     <AddOrEditIMgntType />
                   </Loader>
                </PrivateRoute>
      },
    ],
  },
  {
    path: templateMatserRouteList.formMaster,
    children: [
      {
        path: "",
        element:<PrivateRoute> 
                   <Loader>
                     <FormMaster/>
                   </Loader>
                </PrivateRoute>,
      },
      
    ],
  },
];

export default templateMasterRoutes;